import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faYoutube,
  faLinkedinIn,
  faPinterestP,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

// Tree-shaking: nur genutzte Icons (social links) statt gesamtes fab-Paket
// Icon-Namen: facebook-f, instagram, twitter, youtube, linkedin-in, pinterest-p, whatsapp
library.add(
  faFacebookF,
  faInstagram,
  faTwitter,
  faYoutube,
  faLinkedinIn,
  faPinterestP,
  faWhatsapp
);
